module.exports = __webpack_public_path__ + "img/solveRamme.2c6a25ef.png";